import React from "react";
import { Wrapper } from "./styles";
import NEAPLogo from "../../../../assets/neat/neap_logo.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function TermsHeader() {
  const history = useHistory();
  const handleClick = () => {
    history.push("/");
  };
  return (
    <Wrapper>
      <img
        src={NEAPLogo}
        onClick={handleClick}
        alt=""
        height={"32px"}
        style={{ cursor: "pointer" }}
      />
      <div />
    </Wrapper>
  );
}

export default TermsHeader;
